import { cx } from './cx.js'
import styles from './HairlineRule.module.css'

export interface HairlineRuleProps {
  /** The heavier weight, for separating major sections rather than rows within one. */
  strong?: boolean
}

/**
 * UI spec §8: "Same hairline-rule sectioning" as the marketing site — the
 * one visual device this register uses instead of boxes/shadows to divide
 * content.
 */
export function HairlineRule({ strong = false }: HairlineRuleProps) {
  return <hr className={cx(styles['rule'], strong && styles['strong'])} />
}
